export default {
  // Period specific texts
  start: 'Start',
  end: 'End',
  weeks: 'Weeks',
  closeSections: 'Close Sections',
  startDateValidation: 'This field is required and cannot be equal to or greater than the end date.',
  endDateValidation: 'This field is required and cannot be equal to or less than the start date.',
  closeSectionsDateValidation: 'This field cannot be less than the end date.',
  weeksValidation: 'This field must be an integer greater than zero.',
  noOverlappingValidation: 'Cannot contain another period within the assigned range.',
  notFound: 'No {entity} found.',
  saving: 'Saving...',
  updating: 'Updating...',
  pleaseWaitSaving: 'Please wait while the information is being saved.',
  pleaseWaitUpdating: 'Please wait while the information is being updated.',
  errorCreating: 'There was a problem creating the period.',
  errorUpdating: 'There was a problem updating the period.',
}
